import {writable} from 'svelte/store';

import type {
    DyResponsePopupTypeDesktop,
    DyResponsePopupTypeMobile,
    AnalyticsType,
    SortedDyDataType,
} from 'types/dy';

export const dyData = writable(<DyResponsePopupTypeDesktop & DyResponsePopupTypeMobile>{});

export const analytics = writable(<AnalyticsType>{});

export const popupData = writable(<SortedDyDataType>{});

export const priceData = writable('');

export {customer} from './customer';
export {duration} from './duration';
export {modal} from './modal';
export {sessionData} from './sessionData';
